import { CSSProperties, PropsWithChildren } from "react";

const ModalOverlay: CSSProperties = {
  zIndex: "9999",
  width: "100vw",
  height: "100vh",
  position: "fixed",
  top: "0",
  left: "0",
  background: "rgba(150, 150, 150, 0.7)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
};

const ModalCloseButton: CSSProperties = {
};

const ModalBox: CSSProperties = {
  width: "800px",
  background: "white",
  display: "block",
  padding: "1rem"
};

const ModalContent: CSSProperties = {
  width: "100%",
};

type ModalType = {
  isOpen: boolean;
  toggle: () => void;
  buttonText?: string;
  buttonStyling?: CSSProperties,
  boxStyling?: CSSProperties;
}

export default function Modal({isOpen, toggle, buttonText = "X", buttonStyling = ModalCloseButton, boxStyling = ModalBox, children}: PropsWithChildren<ModalType>) {
  return (
    <>
      {isOpen && (
        <div style={ModalOverlay} onClick={toggle} aria-hidden>
          <div style={boxStyling} onClick={(e) => e.stopPropagation()} aria-hidden>
            <div style={ModalContent}>{children}</div>
            <button style={buttonStyling} className="usa-button" onClick={toggle}>{buttonText}</button>
          </div>
        </div>
      )}
    </>
  );
}